import React from "react";
// import { 
//     Tabs
// } from 'antd';

// Constant

// Services

// Components
import {
    VAMLineItemPanel,
    // VAMLineItemSchedulePanel
} from './components'

// Routes

// Redux Action

// Styling
import './index.css'


const VAMConfigurationManagement = () => {

    return (
        <>
            <VAMLineItemPanel />
            {/* <Tabs 
                defaultActiveKey="0" 
                centered
                items={[
                    {
                        key: '0',
                        label: 'Service Line Item',
                        children: (
                            <>
                                <VAMLineItemPanel />
                            </>
                        )
                    },
                    {
                        key: '1',
                        label: 'Service Line Item Schedule',
                        children: (
                            <>
                                <VAMLineItemSchedulePanel />
                            </>
                        )
                    }
                ]}
            /> */}
        </>
    )
}

export default VAMConfigurationManagement